import { DataDisplay, Header } from '@summer/ui-components';

import { Box } from 'components/box/Box';
import type { SaveTransitionDisplayData } from 'utils/borrower';

const BorrowerSaveTransition = ({
  data,
}: {
  data: SaveTransitionDisplayData;
}) => {
  if (!data) {
    return null;
  }

  return (
    <Box mt={40}>
      {/* @ts-expect-error size overrides the computed font-size and weight is inert — see [sc-52767] */}
      <Header size="large" weight="bold">
        SAVE Transition
      </Header>
      <Box
        bg="white"
        border="solid 1px"
        borderRadius={6}
        borderColor="blueGrey"
        px={24}
        pt={24}
        mt={24}
      >
        <DataDisplay data={data} />
      </Box>
    </Box>
  );
};

export default BorrowerSaveTransition;
